const addScript2 = url => {
  const script = document.createElement("script")
  script.src = url
  document.getElementsByTagName(`head`)[0].appendChild(script)
}
const addScript3 = url => {
  const script = document.createElement("script")
  script.src = url
  document.getElementsByTagName(`body`)[0].appendChild(script)
}

const addTVSquaredScript = () => {
  // Check if window is defined (client-side) and script already exists to prevent duplicates
  if (typeof window !== "undefined" && window._tvq) return

  const script = document.createElement("script")
  script.type = "text/javascript"
  script.innerHTML = `
    var _tvq = window._tvq = window._tvq || [];
    (function() {
      var u = (("https:" == document.location.protocol) ? "https://collector-53765.us.tvsquared.com/" : "http://collector-53765.us.tvsquared.com/");
      _tvq.push(['setSiteId', "TV-4563273645-1"]);
      _tvq.push(['setTrackerUrl', u + 'tv2track.php']);
      _tvq.push([function() {
        this.deleteCustomVariable(5, 'page')
      }]);
      _tvq.push(['trackPageView']);
      var d = document,
      g = d.createElement('script'),
      s = d.getElementsByTagName('script')[0];
      g.type = 'text/javascript';
      g.defer = true;
      g.async = true;
      g.src = u + 'tv2track.js';
      s.parentNode.insertBefore(g, s);
    })();
  `
  document.getElementsByTagName(`head`)[0].appendChild(script)
}

exports.onRouteUpdate = s => {
  addScript2(
    `//scripts.iconnode.com/${process.env.GATSBY_WHATCONVERTS_NUMBER}.js`
  )
  addScript3(process.env.GATSBY_BIRDEYE_CHATBOT_URL)
  addTVSquaredScript()
}
